import { hasStrCodeProperty } from '@app/core/utilities';

export const getFullErrorCode = (preparedErrorData: { strCode: string; code?: number }) => {
  if (hasStrCodeProperty(preparedErrorData)) {
    return preparedErrorData.strCode;
  }

  return '';
};
